import React from 'react';
import useFeatureFlag from '../../hooks/useFeatureFlag';

export const FEATURE_FLAG_NAME = 'sx-show-strikethrough';

const useStrikethroughFeatureFlag = () => {
  const [loading, quickProductSelectorEnabled] = useFeatureFlag(
    FEATURE_FLAG_NAME
  );

  return !loading && quickProductSelectorEnabled;
};

export const withStrikethroughFeatureFlag = Component => {
  return props => {
    const showStrikethroughPricing = useStrikethroughFeatureFlag();

    return (
      <Component
        showStrikethroughPricing={showStrikethroughPricing}
        {...props}
      />
    );
  };
};

export default useStrikethroughFeatureFlag;
